import React, { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import styles from './registration-layuot.module.scss';
export const RegistrationLayoutV4: React.FC<PropsWithChildren> = ({ children }) => {
    return <div className={styles.wrapper}>{<Outlet />}</div>;
};
